import PanelPage from "../../components/panel/panelPage";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { RootState, actions } from "../../state/reducer";
import { useParams } from "react-router-dom";
import EventDetailInfoCard from "../../components/events/infoCard";
import CommentsList from "../../components/comments/list";
import { EventFullData } from "../../types";
import PreloaderPage from "../preloader";
import {
  taskBackend,
  TaskCreationData,
  TaskFullData,
  TaskUpdateData,
  TaskUpdateDataToSave,
} from "../../services/tasks";
import ErrorPage from "../error";
import { FireIcon } from "../../icons/task/important";
import TaskInfoSidePanel from "../../components/task/sidePanel";
import { toast } from "sonner";
import { generateRandomString } from "../../utils";
import { closeModal, openModal } from "../../state/modalSlice";
import TaskUpdateStatusModal from "../../modals/task/updateTaskStatus";
import { commentBackend, CommentOutput, statsBackend } from "../../services";

const TaskDetailPage = () => {
  const [isPending, setPending] = useState(false);
  const [editable, setEditable] = useState(false);
  const [taskData, setTaskData] = useState<TaskFullData | null>(null);
  const [dataToSave, setDataToSave] = useState<TaskUpdateData | null>(null);
  const [comments, setComments] = useState<CommentOutput[]>([]);
  const [errored, setErrored] = useState(false);
  const { taskid } = useParams();
  const [update, triggerUpdate] = useState(true);
  const State = useSelector((state: RootState) => state);
  const dispatch = useDispatch();

  const isImportant = taskData?.is_important;

  if (!taskid || isNaN(Number(taskid)) || errored) {
    return <ErrorPage code={404} message={"Событие не найдено"} />;
  }
  const session = State.session;
  const trigger = State.selectedItem;

  useEffect(() => {
    if (taskData) {
      commentBackend
        .getComments(taskData.id, 2)
        .then((res) => {
          setComments(res.comments);
        })
        .catch(() => {
          toast("Не удалось загрузить комментарии");
        });
    }
  }, [taskData]);

  useEffect(() => {
    try {
      taskBackend
        .getTaskFullData(Number(taskid))
        .then((res) => {
          if (res?.task) {
            setTaskData(res.task);
            const editableData: TaskUpdateData = {
              task_id: res.task.id,
              title: res.task.title,
              description: res.task.description,
              date_end: res.task.date_end,
              is_important: res.task.is_important,
              status_id: res.task.status_id,
            };
            setDataToSave(editableData);
          } else {
            setErrored(true);
          }
        })
        .catch((e) => {
          setErrored(true);
        });
    } catch (e) {
      console.log(e);
    }
  }, [trigger]);

  if (!taskData || !dataToSave) {
    return <PreloaderPage />;
  }

  const updateAction = (
    param: keyof TaskUpdateData,
    value: any,
    save?: boolean
  ) => {
    const updateData: TaskUpdateData = {
      ...dataToSave,
      [param]: value,
    };
    if (save) {
      saveData({
        ...updateData,
        date_end: updateData.date_end
          ? new Date(updateData.date_end).getTime()
          : undefined,
      });
    } else {
      setDataToSave(updateData);
    }
  };

  const saveData = (data: TaskUpdateDataToSave) => {
    if (isPending) return;
    setPending(true);
    toast("Сохранение...");
    return new Promise((resolve) => {
      taskBackend
        .updateTask({
          ...data,
          date_end: data.date_end
            ? new Date(data.date_end).getTime()
            : undefined,
        })
        .then(() => {
          toast("Данные обновлены");
          dispatch(actions.selectItem(generateRandomString(4)));
        })
        .catch((e) => {
          toast("Ошибка обновления данных");
        })
        .finally(() => {
          setPending(false);
          setEditable(false);
          resolve(1);
        });
    });
  };
  // onSave(task_id, selectedStatus, comment, selectedDateEnd);
  const handleOpenStatusModal = () => {
    dispatch(
      openModal({
        component: TaskUpdateStatusModal,
        context: {
          task_id: taskData.id,
          def_status_id: taskData.status_id,
          def_date_end: taskData.date_end,
          onSave: (
            task_id: number,
            status_id: number,
            comment: string,
            date_end?: string
          ) => {
            const updateData: TaskUpdateData = {
              ...dataToSave,
              status_id: status_id,
            };
            setDataToSave(updateData);
            Promise.all([
              commentBackend.addComment({
                tab_id: 2,
                item_id: task_id,
                comment,
              }),
              saveData({
                ...updateData,
                date_end: date_end ? new Date(date_end).getTime() : undefined,
              }),
            ])
              .then((res) => {
                if (res) {
                  dispatch(actions.selectItem(generateRandomString(4)));
                  toast("Данные по задаче обновлены");
                }
              })
              .catch((err) => {
                toast("Ошибка сохранения данных");
              })
              .finally(() => {
                dispatch(closeModal());
              });
          },
          closeModal: () => dispatch(closeModal()), // Закрыть модальное окно через Redux
        },
      })
    );
  };

  return (
    <PanelPage>
      <div className="panelColumnFull">
        <div className="profileWidget detail">
          <div className="flex between w100 panelColumnFull">
            <div className="columnCenter panelColumnMain">
              <div className="panel eventListPanel h100 columnCenter between">
                <div className="flex between w100 vertCenter">
                  <div className="panelHeading">
                    {!editable ? (
                      <h3>
                        Задача № {taskid} - {taskData.title}
                      </h3>
                    ) : (
                      <input
                        className="headingInput"
                        style={{
                          marginLeft: 24,
                        }}
                        type="text"
                        value={dataToSave.title}
                        onChange={(event) =>
                          updateAction("title", event.target.value, false)
                        }
                      />
                    )}
                  </div>
                  <a
                    className={`flex gap6 importantTask${
                      isImportant ? " important" : ""
                    }`}
                    onClick={updateAction.bind(
                      this,
                      "is_important",
                      !isImportant,
                      true
                    )}
                  >
                    <span>
                      {!isImportant
                        ? "Сделать важной задачей"
                        : "Важная задача"}
                    </span>
                    <FireIcon width={16} height={19} />
                  </a>
                </div>
                <div className="clientCardBody flex between w100 h100">
                  <div className="taskDescription h100">
                    {editable ? (
                      <textarea
                        className="taskDescriptionEditor"
                        rows={12}
                        value={dataToSave.description}
                        onChange={(event) =>
                          updateAction("description", event.target.value, false)
                        }
                      />
                    ) : taskData.description ? (
                      <pre>{taskData.description}</pre>
                    ) : (
                      <div className="gridCenter">Нет описания</div>
                    )}
                  </div>
                </div>
                <div className="flex btnRow taskBtnRow">
                  {!editable ? (
                    <>
                      <div
                        className="btn taskEditBtn green"
                        onClick={handleOpenStatusModal}
                      >
                        Сменить статус
                      </div>
                      <div
                        className="btn taskEditBtn gray"
                        onClick={() => setEditable(true)}
                      >
                        Редактировать
                      </div>
                    </>
                  ) : (
                    <>
                      <div
                        className="btn taskEditBtn green"
                        onClick={() =>
                          saveData({
                            ...dataToSave,
                            date_end: dataToSave.date_end
                              ? new Date(dataToSave.date_end).getTime()
                              : undefined,
                          })
                        }
                      >
                        Сохранить
                      </div>
                      <div
                        className="btn taskEditBtn gray"
                        onClick={() => setEditable(false)}
                      >
                        Отменить
                      </div>
                    </>
                  )}
                </div>
              </div>
            </div>
            <div className="columnCenter panelColumnSub">
              <TaskInfoSidePanel task={taskData} />
            </div>
          </div>
          <div
            className="flex between w100 panelColumnFull"
            style={{ marginTop: 24 }}
          >
            <div className="columnCenter panelColumnMain taskCommentTab">
              <div className="panel eventListPanel">
                <CommentsList tab={2} item={taskData.id} comments={comments} />
              </div>
            </div>
          </div>
        </div>
      </div>
    </PanelPage>
  );
};

export default TaskDetailPage;
